import { useEffect, useState } from 'react';
import api from './utils/api';
import AuthForm from './components/AuthForm';
import InviteForm from "./components/InviteForm";
import TopBar from "./components/TopBar";
import {log}  from "./utils/debug";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { Routes, Route, useNavigate } from "react-router-dom";
import ManageEvents from "./components/ManageEvents";
import InviteDetails from "./components/InviteDetails";
import RSVPForm from "./components/RSVPForm";

function App() {
  const navigate = useNavigate();
  const [currentUser, setCurrentUser] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [recipients, setRecipients] = useState([{ name: '', email: '' }]);
  const [data, setData] = useState({
    sender_name: '',
    sender_email: '',
    event_title: '',
    message: '',
    event_start: '',
    event_end: '',
    location: '',
  });

  // Check auth status once on load
  useEffect(() => {
    const token = localStorage.getItem("access_token");
    log("🧪 Checking token on load:", token);
    if (token) {
      setIsLoggedIn(true);

      const decoded = JSON.parse(atob(token.split(".")[1]));
      setCurrentUser({ id: decoded.sub });
    }
  }, []);


  const handleChange = (e) => setData({ ...data, [e.target.name]: e.target.value });

  const handleLogout = () => {
    api.post("/logout", {}, { withCredentials: true });

    localStorage.removeItem("access_token");
    setIsLoggedIn(false);
    navigate("/");
  };

  const uploadFlyer = async (flyerFile) => {
    const formData = new FormData();
    formData.append("flyer", flyerFile);

    const response = await api.post("/upload-flyer", formData, {
      withCredentials: true,
      headers: {
        // ✅ Do NOT set Content-Type — let the browser handle it
      }
    });

    return response.data.flyer_url;
  };

  const sendInvite = async (messageHTML, flyerFile) => {
    try {
      const token = localStorage.getItem("access_token");

      let flyer_url = null;
      if (flyerFile) {
        const uploadRes = await uploadFlyer(flyerFile);
        flyer_url = uploadRes; // already a string URL
        console.log("📎 Flyer uploaded. URL:", flyer_url);
      }

      const payload = {
        ...data,
        message: messageHTML,
        sender_name: currentUser?.name,
        sender_email: currentUser?.email,
        recipients: recipients.filter(r => r.name && r.email),
        flyer_url
      };

      const response = await api.post('/send-invite', payload, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true
      });

      if (response.data.status === 'success') {
        console.log("✅ Invites sent!");
        setData({
          sender_name: '',
          sender_email: '',
          event_title: '',
          event_start: '',
          event_end: '',
          location: '',
          message: '',
          recipients: ''
        });
        setRecipients([{ name: '', email: '' }]);
        navigate("/manage");
      } else {
        console.log("Something went wrong while sending invites.");
      }
    } catch (err) {
      console.error("Error sending invites:", err);
    }
  };

  const isProtectedRoute = !["/rsvp"].includes(location.pathname);

  if (isProtectedRoute && !isLoggedIn) {
    return (
      <div className="unAuth">
        <Header />
        <AuthForm onAuth={() => setIsLoggedIn(true)} />
        <Footer />
      </div>
    );
  }

  log("✅ Logged in. Showing invite form.");  

  return (
    <>
      <TopBar isLoggedIn={isLoggedIn} onLogout={handleLogout} />
      <Header />
  
      <Routes>
        <Route
          path="/"
          element={
            isLoggedIn ? (
              <InviteForm
                data={data}
                setData={setData} 
                onChange={handleChange}
                onSubmit={sendInvite}
                recipients={recipients}
                setRecipients={setRecipients}
              />
            ) : (
              <AuthForm onAuth={() => setIsLoggedIn(true)} />
            )
          }
        />
        <Route
          path="/manage"
          element={
            isLoggedIn ? (
              <ManageEvents />
            ) : (
              <AuthForm onAuth={() => setIsLoggedIn(true)} />
            )
          }
        />
        <Route path="/invite/:inviteId" element={<InviteDetails />} />
        <Route path="/rsvp" element={<RSVPForm />} />
      </Routes>
      <Footer />
    </>
  );
  
}

export default App;